import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonService, SharedserviceService } from 'src/app/services';
import { MustMatch } from 'src/app/services/must-match';
declare var $: any;

@Component({
  selector: 'app-home-sector',
  templateUrl: './home-sector.component.html',
  styleUrls: ['./home-sector.component.scss']
})
export class HomeSectorComponent implements OnInit {
  usertype:any='user';
  id: any;
  logForm: FormGroup;
  token: any;
  user_id: any;
  errors: any;
  hidediv: boolean = false;
  show: boolean = false;
  // submitted:boolean = false;
  submitted = false;
  type: any;
  btndisabled2: boolean = true;
  btndisabled: boolean = false;
  // loginShow:boolean=true;
  loginShow: boolean = true;
  signupShow: boolean = false;
  forgotShow: boolean = false;
  verifyShow: boolean = false;

  data: any; keys: any; public page: number = 1; start = 0; msg: any
  ccData: any;
  TotalCount: any;
  totalpage: any;
  total: any;
  element: any;
  travellers: FormGroup;
  formEmail: FormGroup;
  searchForm: FormGroup;
  offerList: any;
  DataReturn: any;
  flight_Type: any;
  banner: any;
  combine: any = [];
  ImgBanner: any;
  ownerData:any = JSON.parse(sessionStorage.getItem("ownerData"))
  forgotpass: FormGroup;
  // //******signup any type start*******//
  // regForm: FormGroup;
  // selectptype: any = 'Select Type';
  // success: any;
  // matchpasserr: boolean = false;
  // matchCaptcha: boolean = false;
  // val: any;
  // //******signup any type end*******//

//******signup any type start*******//
regForm: FormGroup;
selectptype: any = 'Select Type';
success: any;
matchpasserr: boolean = false;
matchCaptcha: boolean = false;
val: any;

image:any;
gstimage:any;
panimage:any;
aadharfimage:any;
aadharbimage:any;
public imagePath;
imgFile: File=null;
gstFile: File=null;
panFile: File=null;
aadharFile: File=null;
aadharbFile: File=null;
public message: string;
public gstmessage: string;
public panmessage: string;
public aadharfmessage: string;
public aadharbmessage: string;
//******signup any type end*******//


  //******verify any type start*******//
  verify: FormGroup;
  u_email: any = JSON.parse(localStorage.getItem("user_emailAgency"));
  user_email: any;
  sc_type: any;
  register: any;
  matcherror: boolean = false;
  getData: any;
  min = 1;
  max = 6;
  RandomTotal:any;
  minNum = 1;
  maxNum = 10;
  randomNumber1: number;
  randomNumber2: number;
  //******verify any type end*******//
  userdata: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    public sharedService: SharedserviceService,
    public commonService: CommonService,
    private ngxLoader: NgxUiLoaderService,
    private toastr: ToastrManager,
    private fb: FormBuilder,
    public router: Router,) {
    this.userdata = JSON.parse(localStorage.getItem("user_emailAgency"));
    if (this.userdata != null) {
      this.user_email = this.userdata.email;
      this.sc_type = localStorage.getItem("type")
    }
    console.log('this.userdata =========================================== 119 ===', this.userdata);
    
  }




  ngOnInit() {
    // this.RandomInt1 = Math.floor(Math.random() * 11) + 1;
    // console.log("check random number1:::::::",this.RandomInt1);
    // this.RandomInt2 = Math.floor(Math.random() * 9)+1
    // console.log("check random number 2",this.RandomInt1);
    
    // this.RandomTotal = Math.floor(this.RandomInt1 + this.RandomInt2);
    // console.log("total random number",this.RandomTotal);

    this.contactDetail();
    this.formEmail = this.fb.group({
      email: [''],
      Name: [''],
      subject: [''],
      message: [''],
      mobile_no: [''],
      company_name: ['']
    });
    this.verify = this.fb.group({
      otp: ['', Validators.required],
      password: ['', Validators.required],
      confirm_password: ['', Validators.required],
      email: [''],
    });

    this.forgotpass = this.fb.group({
      email: ['', Validators.required],
    });
    // this.loginClick(this.val);
    // ******* for signup start******
    this.regForm = this.fb.group({
      role_id: [''],
      name: ['', Validators.required],
      email: ['', Validators.required],
      company_name: [''],
      pan_no: [''],
      mobile: ['', [Validators.required, Validators.maxLength(10)]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required, Validators.minLength(6)]],
    }, {
      validator: MustMatch('password', 'confirmPassword')
    });
    // ******* for signup end******
    if (this.commonService.getToken()) {
      // this.router.navigate(['/dashboard']);
      this.router.navigate(['/offerin']);
    }
    this.logForm = this.fb.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
      // captcha: ['', Validators.required],
      device_token: ["44634w8q7d7edwq6eqw46"],
      device_type: ["web"]
    });
    var offerd = localStorage.getItem('offerDetail');
    var treveld = localStorage.getItem('travlerDetail');
    if (treveld && offerd) {
      this.router.navigateByUrl("/offerin");
    }
    // this.offersListOneway();
    // this.offersListReturn();
    this.sliderBanner();
    this.searchForm = this.fb.group({
      adult: 1,
      child: 0,
      infant: 0
    })
    this.travellers = this.fb.group({
      adult: ['1'],
      child: ['0'],
      infant: ['0'],
    });
    this.getRandomIntInclusive();
    this.getRandomIntInExclusive()
  }


  getRandomIntInclusive() {
    this.minNum = Math.ceil(this.minNum);
    this.maxNum = Math.floor(this.maxNum);
    this.randomNumber1 = Math.floor(Math.random() * (this.maxNum - this.minNum + 1) + this.minNum); //The maximum is inclusive and the minimum is inclusive
    // console.log("check new random No=================", this.randomNumber1);
  }
  getRandomIntInExclusive() {
    this.min = Math.ceil(this.min);
    this.max = Math.floor(this.max);
    this.randomNumber2 = Math.floor(Math.random() * (this.max - this.min + 1) + this.min); //The maximum is inclusive and the minimum is inclusive
    // console.log("check new random No=================", this.RandomTotal);
    console.log("total genrate number:::::::::",this.randomNumber1+this.randomNumber2);
    this.RandomTotal = this.randomNumber1+this.randomNumber2;
    console.log('this.RandomTotal ===', this.RandomTotal);
  }

  checkTerms(event){
    var checkvlue = event.checked;
    console.log("checkvalue============>>>>",checkvlue);
    if(checkvlue==true){
      this.btndisabled2 =false;
    }else{
      this.btndisabled2 =true
    }
  }

  submitForm() {
    $('#contactForm').modal('show');
  }

  submitFormEmail() {
    this.submitted = true;
    if (this.formEmail.invalid) {
      return;
    } else {
      var sedData = {
        "email": this.formEmail.value.email,
        "Name": this.formEmail.value.Name,
        "subject": "",
        "message": this.formEmail.value.message,
        "mobile_no": this.formEmail.value.mobile_no,
        "company_name": this.formEmail.value.company_name
      }
      this.sharedService.post('v1/pages/contact_us', sedData).subscribe((res) => {
        if (res.replyCode == 'success') {
          this.DataReturn = res.data
          $('#contactForm').modal('hide');
          // console.log("ReturnData::::::",this.DataReturn);
        } else {
          this.toastr.errorToastr(res.replyMsg, 'Error', { timeOut: 500 });
        }
      }, err => {
        this.toastr.errorToastr(err.error.replyMsg, 'Error', { timeOut: 500 });
      });
    }
  }

   //**********for signup **********/
  loadType() {
    this.sharedService.get('v1/role_list').subscribe((res) => {
      if (res.replyCode == 'success') {
        this.type = res.data;
      }
    });
  }

  get s() { return this.regForm.controls; }
  password() {
    this.show = !this.show;
  }

  // regUser() {
  //   this.submitted = true;
  //   if (this.regForm.invalid) {
  //     return;
  //   } else {
  //     this.hidediv = true;
  //     // this.showloader()
  //     const self = this;
  //     self.btndisabled = true;
  //     self.sharedService.loadingShow = true;
  //     var bodyObject = {
  //       // "role_id":this.regForm.value.role_id,
  //       "role_id": 2,
  //       "name": this.regForm.value.name,
  //       "email": this.regForm.value.email,
  //       "mobile": this.regForm.value.mobile,
  //       "company_name": this.regForm.value.company_name,
  //       "pan_no": this.regForm.value.pan_no,
  //       "password": this.regForm.value.password,
  //       "device_token": "44634w8q7d7edwq6eqw46",
  //       "device_type": "web",
  //     }
  //     this.sharedService.post('v1/users/registration', bodyObject).subscribe((res) => {
  //       if (res.replyCode == 'success') {
  //         self.btndisabled = false;
  //         this.submitted = false;
  //         this.regForm.reset();
  //         // self.router.navigate(['/home-sector']);
  //         window.location.reload();
  //         this.toastr.successToastr(res.replyMsg, 'Success');
  //       } else {
  //         self.btndisabled = false;
  //         // this.hideloader()
  //         this.hidediv = false;
  //         this.toastr.errorToastr(res.message, 'Error');
  //       }
  //     }, err => {
  //       self.btndisabled = false;
  //       // this.hideloader()
  //       this.hidediv = false;
  //       if (err['error'].replyMsg[0].message) {
  //         this.toastr.errorToastr(err['error'].replyMsg[0].message, 'Error');
  //       } else {
  //         this.toastr.errorToastr(err['error'].replyMsg, 'Error');
  //       }

  //     });
  //   }
  // }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  charactoronly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    // allow letters and whitespaces only.
    if (!(charCode >= 65 && charCode <= 122) && (charCode != 32 && charCode != 0)) {
      return false;
    }
    return true;
  }

  matchpassword() {
    if (this.regForm.value.password != this.regForm.value.confirmPassword) {
      this.matchpasserr = true;
    } else { this.matchpasserr = false; }
  }


  matcCaptcha() {
    if (Number(this.logForm.value.captcha) == this.RandomTotal) {
      // console.log("check value text :::::======",this.logForm.value.captcha);
      
      this.matchCaptcha = true;
    } else { this.matchCaptcha = false; }
  }
  //**********for signup **********/


  //**********for Login **********/
  loginClick(val) {
    var valueCheck = val;
    // console.log("check click value", valueCheck);
    if (valueCheck == 'login') {
      this.loginShow = true;
      this.signupShow = false;
      this.forgotShow = false;
      this.verifyShow = false;
    }
    else if (valueCheck == 'register') {
      this.loginShow = false;
      this.signupShow = true;
      this.forgotShow = false;
      this.verifyShow = false;
    }
    else if (valueCheck == 'forgot') {
      this.loginShow = false;
      this.signupShow = false;
      this.forgotShow = true;
      this.verifyShow = false;
    }
    else if (valueCheck == 'verify') {
      this.loginShow = false;
      this.signupShow = false;
      this.forgotShow = false;
      this.verifyShow = true;
    }
    // this.loginShow = ! this.loginShow;
  }


  contactDetail() {

    const self = this;
    self.sharedService.get('v1/users/get_website_owner_data').subscribe((res: any) => {
      if (res.replyCode == "success") {
        this.getData = res.data;
        console.log("::::::::::::::",this.getData);
        sessionStorage.setItem("ownerData",JSON.stringify(this.getData))
      } else {
        
      }
    });
  }


  // offersListOneway() {
  //   this.ngxLoader.start();
  //   var sedData = {
  //     name: ""
  //   }
  //   this.sharedService.post('v1/search_offer_flight/sectors_list_oneway', sedData).subscribe((res) => {
  //     if (res.replyCode == 'success') {
  //       (res.data).forEach(element => {
  //         this.combine.push(element)
  //         this.combine.sort((a, b) => a.departure_city_name.localeCompare(b.departure_city_name));
  //       });
  //       this.data = res.data;
  //       this.ccData = res.data;
  //       console.log('sunil:::::::', this.ccData)
  //       // this.keys = Object.keys(this.data[0]);
  //       // this.TotalCount = res.totalRecords
  //       // this.totalpage=res.totalPage
  //       this.ngxLoader.stop();
  //     } else {
  //       this.ngxLoader.stop();
  //       this.toastr.errorToastr(res.replyMsg, 'Error', { timeOut: 500 });
  //     }
  //   }, err => {
  //     this.ngxLoader.stop();
  //     this.toastr.errorToastr(err.error.replyMsg, 'Error', { timeOut: 500 });
  //   });
  // }

  sliderBanner() {
    this.sharedService.get('v1/banner/list').subscribe((res) => {
      if (res.replyCode == 'success') {
        this.ImgBanner = res.imageURL;
        if (res.data.length > 0) {
          this.banner = res.data;
          console.log("banner Data :::::::::", this.banner);
        }
      } else {
        this.ngxLoader.stop();
        this.toastr.errorToastr(res.replyMsg, 'Error', { timeOut: 500 });
      }
    })

  }
  

  // offersListReturn() {
  //   this.ngxLoader.start();
  //   var sedData = {
  //     name: ""
  //   }
  //   this.sharedService.post('v1/search_offer_flight/sectors_list_return', sedData).subscribe((res) => {
  //     if (res.replyCode == 'success') {

  //       (res.data).forEach(element => {
  //         this.combine.push(element)
  //         this.combine.sort((a, b) => a.departure_city_name.localeCompare(b.departure_city_name));
  //       });
  //       this.DataReturn = res.data
  //       console.log("ReturnData::::::", this.DataReturn);
  //       // this.ccData=res.data;
  //       this.ngxLoader.stop();
  //     } else {
  //       this.ngxLoader.stop();
  //       this.toastr.errorToastr(res.replyMsg, 'Error', { timeOut: 500 });
  //     }
  //   }, err => {
  //     this.ngxLoader.stop();
  //     this.toastr.errorToastr(err.error.replyMsg, 'Error', { timeOut: 500 });
  //   });
  // }

  // checkOffer(list) {
  //   // checkOffer(list,type){
  //   $('#totalpassengers').modal('show');
  //   console.log("offerList Data", list);
  //   this.offerList = list;
  //   sessionStorage.setItem("offerDetail", JSON.stringify(this.offerList));
  //   // sessionStorage.setItem("offerType", JSON.stringify(type));
  // }

  // traveller() {
  //   var adult = this.travellers.value.adult;
  //   var child = this.travellers.value.child;
  //   var infant = this.travellers.value.infant;

  //   if (adult != '' && child != '' && infant != '') {
  //     if (parseInt(adult) >= parseInt(infant)) {
  //       this.total = parseInt(adult) + parseInt(child) + parseInt(infant);

  //       this.searchForm.patchValue({
  //         adult: parseInt(adult),
  //         child: parseInt(child),
  //         infant: parseInt(infant)
  //       });

  //       $('#totalpassengers').modal('hide');
  //       this.searchForm.patchValue({ travellers: this.total });
  //       console.log("Total travlers:::::", this.searchForm.value);
  //       sessionStorage.setItem("travlerDetail", JSON.stringify(this.searchForm.value));
  //       this.router.navigateByUrl("/offer-view");
  //     } else {
  //       alert('Please select infant less than adult');
  //     }

  //   } else {
  //     alert('All Field is required');
  //   }
  // }



  get lf() { return this.logForm.controls; }

  logUser() {
    console.log("asddadadasawd", this.logForm.value);
    this.submitted = true;
    console.log("matchCaptcha check;;;;;;;;;;;;;;;",this.matchCaptcha);    
    // console.log("loginvalue check;;;;;;;;;;;;;;;",this.logForm.value);    
    // if (this.logForm.invalid || this.matchCaptcha == false) {
    if (this.logForm.invalid) {
      return;
    } else {
      // this.hidediv = true;
      // this.showloader()
      var self = this;
      self.btndisabled = true;
      this.sharedService.post('v1/users/login', this.logForm.value).subscribe((res) => {
        if (res.replyCode == 'success') {
          // this.hideloader()
          var role = res.data.role_id;
          if(role != 2){
          // localStorage.clear();
          // sessionStorage.clear()
          localStorage.setItem("userAgency", JSON.stringify(res.data));
          localStorage.setItem("imgpathAgency", JSON.stringify(res.imageurl));
          localStorage.setItem("tokenAgency", JSON.stringify(res.data.login_token));
          this.toastr.successToastr(res.replyMsg, 'Success');
          // this.router.navigateByUrl('/dashboard');
          this.router.navigateByUrl('/offerin');
           }else{  
          this.toastr.errorToastr('Waiting for Approval', '');
          self.btndisabled= false; 
          }
        } else {
          self.btndisabled = false;
          // this.hideloader()
          this.hidediv = false;
          this.toastr.errorToastr(res.replyMsg, 'Error');
        }
      }, err => {
        // this.hideloader()
        this.hidediv = false;
        // self.sharedService.loadingShow = false;
        self.btndisabled = false;
        self.toastr.errorToastr(err.error.replyMsg, "Error")
      });
    }
  }

  // hideloader() { 
  //   document.getElementById('loader').style.display = 'none'; 
  // }
  // showloader() { 
  //   document.getElementById('loader').style.display = 'block'; 
  // }
  checkPwd() {
    this.show = !this.show;
  }
  //**********for Login end**********/


  //**********for forgot start******/
  get fgt() { return this.forgotpass.controls; }
  forgot() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.forgotpass.invalid) {
      return;
    }
    const self = this;
    self.sharedService.loadingShow = true;
    this.sharedService.patch('v1/users/forgot_password', this.forgotpass.value).subscribe((res) => {
      self.sharedService.loadingShow = false;
      if (res.replyCode == 'success') {
        localStorage.setItem("user_emailAgency", JSON.stringify(this.forgotpass.value));
        localStorage.setItem("type", 'forgot');
        self.success = res.success;
        $('#success').show();
        setTimeout(function () {
          $('#success').hide();
          self.router.navigate(['/home-sector']);
        }, 2000);
        this.loginClick('verify');
      } else {
        self.errors = res.errors;
        $('#error').show();
        setTimeout(function () {
          $('#error').hide();
        }, 4000);

      }
    }, err => {
      self.toastr.errorToastr(err['error'].replyMsg, 'Error');
    });
  }
  //**********for forgot end******/


  //**********for veryfy pwd start******/
  get verifypwd() { return this.verify.controls; }
  verify_user() {

    this.submitted = true;
    // stop here if form is invalid
    if (this.verify.invalid) {
      return;
    }
    const self = this;
    self.sharedService.loadingShow = true;
    // console.log('JSON.parse(localStorage.getItem("user_emailAgency")) ============================================== 619 ===', JSON.parse(localStorage.getItem("user_emailAgency")));
    // console.log('this.userdata ============================================== 620 ===', this.userdata);
    // console.log('this.u_email ============================================== 621 ===', this.u_email);
    // console.log('this.userdata.email ============================================== 622 ===', this.userdata.email);
    
    self.verify.patchValue({ email: (JSON.parse(localStorage.getItem("user_emailAgency"))).email });

    this.sharedService.patch('v1/users/reset_password', this.verify.value).subscribe((res) => {
      self.sharedService.loadingShow = false;
      if (res.replyCode == 'success') {
        this.toastr.successToastr(res.replyMsg, 'Success');
        if (this.sc_type == 'register') {
          $('#success').show(1000);
          setTimeout(function () {
            $('#success').hide(1000);
            self.router.navigate(['/home-sector']);
          }, 2000);
        } else {
          self.router.navigate(['/home-sector']);
        }
        this.loginClick('login');
      } else {
        $('#error').show(1000);
        setTimeout(function () {
          $('#error').hide(1000);
        }, 4000);
      }
    }, err => {
      this.toastr.errorToastr(err.error.replyMsg, 'Error');
    });
  }

  match(val) {
    var pass = this.verify.value
    if (val != pass.password) {
      this.matcherror = true;
    } else {
      this.matcherror = false;
    }
  }

  resendOTP() {
    var email = {
      'email': this.user_email,
    }
    const self = this;
    this.sharedService.loadingShow = true;
    this.sharedService.patch('resend', email).subscribe((res) => {
      self.sharedService.loadingShow = false;
      if (res.success) {
        alert('OTP Send Successfully');
      } else {
        $('#error').show(1000);
        setTimeout(function () {
          $('#error').hide(1000);
        }, 4000);
      }

    });

  }
  //**********for veryfy pwd end******/

  // userinfo(type){
  //   console.log("check type condition:::::::", type);
    
  //   if(type == 'user'){
  //     this.usertype='user';
  //     this.regForm = this.fb.group({
  //       role_id:[''],
  //       name:['', Validators.required],
  //       email:['', Validators.required],
  //       company_name:[''],
  //       pan_no:[''],
  //       mobile:['', [Validators.required, Validators.maxLength(10)]],
  //       password: ['', [Validators.required, Validators.minLength(6)]],
  //       confirmPassword: ['', [Validators.required,Validators.minLength(6)]],
  //     },{
  //       validator: MustMatch('password', 'confirmPassword')
  //     });
  //   }
  //   else{
  //     this.usertype = 'agent';  
  //     this.regForm = this.fb.group({
  //       role_id:[''],
  //       name:['', Validators.required],
  //       email:['', Validators.required],
  //       company_name:['',Validators.required],
  //       pan_no:['',Validators.required,Validators.pattern],
  //       mobile:['', [Validators.required, Validators.maxLength(10)]],
  //       password: ['', [Validators.required, Validators.minLength(6)]],
  //       confirmPassword: ['', [Validators.required,Validators.minLength(6)]],
  //     },{
  //       validator: MustMatch('password', 'confirmPassword')
  //     });
  //   }  
  // }
  hideloader() { 
    document.getElementById('loader').style.display = 'none'; 
  }
  showloader() { 
    document.getElementById('loader').style.display = 'block'; 
  }

  get f() { return this.regForm.controls; }
  regUser(){
    this.submitted = true;
    if (this.regForm.invalid) { 
      console.log("awdasdasdasdawdwadw",this.regForm.value)
      return;
    }else{
      this.hidediv=true;
      this.showloader()
      const self=this;
      self.btndisabled= true;
      self.sharedService.loadingShow = true;
      var bodyObject;
      if(this.usertype == 'user'){
        bodyObject={
          // "role_id":this.regForm.value.role_id,
          "role_id":2,
          "name":this.regForm.value.name,
          "email":this.regForm.value.email,
          "mobile":this.regForm.value.mobile,
          "password":this.regForm.value.password,
          "device_token":"44634w8q7d7edwq6eqw46",
          "device_type":"web",
        }

        this.sharedService.post('v1/users/registration',bodyObject).subscribe((res)=> {
          if(res.replyCode == 'success'){
            self.btndisabled= false;
            this.submitted = false;
            this.regForm.reset();
            // self.router.navigate(['/home-sector']);
            window.location.reload();
            this.toastr.successToastr(res.replyMsg, 'Success');
          }else{
            self.btndisabled= false; 
            this.hideloader()
            this.hidediv=false;
            this.toastr.errorToastr(res.message, 'Error');
          }
        },err=>{
          self.btndisabled= false; 
          this.hideloader()
          this.hidediv=false;
          if(err['error'].replyMsg[0].message){
            this.toastr.errorToastr(err['error'].replyMsg[0].message, 'Error');
          }else{
            this.toastr.errorToastr(err['error'].replyMsg, 'Error');
          }
          
        });
      }else{
        const self=this;
        self.btndisabled= true;
        self.sharedService.loadingShow = true;
        const bodyObject = new FormData();
        if(self.imgFile == null){  bodyObject.append('image','');  }else{  bodyObject.append('image', self.imgFile, self.imgFile.name);  }
        if(self.gstFile == null){  bodyObject.append('gst','');  }else{  bodyObject.append('gst', self.gstFile, self.gstFile.name);  }
        if(self.panFile == null){  bodyObject.append('pan','');  }else{  bodyObject.append('pan', self.panFile, self.panFile.name);  }
        if(self.aadharFile == null){  bodyObject.append('aadhaar_front','');  }else{  bodyObject.append('aadhaar_front', self.aadharFile, self.aadharFile.name);  }
        if(self.aadharbFile == null){  bodyObject.append('aadhaar_back','');  }else{  bodyObject.append('aadhaar_back', self.aadharbFile, self.aadharbFile.name);  }
        bodyObject.append("role_id",'2');
        bodyObject.append('name', self.regForm.value.name);
        bodyObject.append('email', self.regForm.value.email);
        bodyObject.append('company_name', self.regForm.value.company_name);
        bodyObject.append('city', self.regForm.value.city);
        bodyObject.append('state_id', self.regForm.value.state);
        bodyObject.append('country_id', self.regForm.value.country);
        bodyObject.append('address', self.regForm.value.address_1);
        bodyObject.append('address_2', self.regForm.value.address_2);
        bodyObject.append('aadhar_no', self.regForm.value.aadhar_no);
        bodyObject.append('pan_no', self.regForm.value.pan_no);
        bodyObject.append('gst_no', self.regForm.value.gst_no);
        bodyObject.append('zipcode', self.regForm.value.zipcode);
        bodyObject.append('mobile', self.regForm.value.mobile);
        bodyObject.append('password', self.regForm.value.password);
        bodyObject.append('device_token', "44634w8q7d7edwq6eqw46");
        bodyObject.append('device_type', 'web');

        
        this.sharedService.postRequest('v1/users/registration',bodyObject).subscribe((res)=> {
          if(res.replyCode == 'success'){
            self.btndisabled= false;
            this.submitted = false;
            this.regForm.reset();
            // self.router.navigate(['/home-sector']);
            window.location.reload();
            this.toastr.successToastr(res.replyMsg, 'Success');
          }else{
            self.btndisabled= false; 
            this.hideloader()
            this.hidediv=false;
            this.toastr.errorToastr(res.message, 'Error');
          }
        },err=>{
          self.btndisabled= false; 
          this.hideloader()
          this.hidediv=false;
          if(err['error'].replyMsg[0].message){
            this.toastr.errorToastr(err['error'].replyMsg[0].message, 'Error');
          }else{
            this.toastr.errorToastr(err['error'].replyMsg, 'Error');
          }
          
        });
      }
    }
  }

  onFileChanged(event) {
    var imagesize =Number(event.target.files[0].size)
    if(imagesize <= 300000){
      this.gstFile = event.target.files[0];
      this.preview(event.target.files);
    } else{
      this.toastr.errorToastr("GST should be less than 300 kb ", 'Error');
    }   
  }

  onFileChanged1(event) {
    var imagesize =Number(event.target.files[0].size)
    if(imagesize <= 300000){
      this.panFile = event.target.files[0];
      this.preview1(event.target.files);
    } else{
      this.toastr.errorToastr("pancard should be less than 300 kb ", 'Error');
    }   
  }

  onFileChanged2(event) {
    var imagesize =Number(event.target.files[0].size)
    if(imagesize <= 300000){
      this.aadharFile = event.target.files[0];
      this.preview2(event.target.files);
    } else{
      this.toastr.errorToastr("Aadhar Front should be less than 300 kb ", 'Error');
    }   
  }

  onFileChanged3(event) {
    var imagesize =Number(event.target.files[0].size)
    if(imagesize <= 300000){
      this.aadharbFile = event.target.files[0];
      this.preview3(event.target.files);
    } else{
      this.toastr.errorToastr("Aadhar back should be less than 300 kb ", 'Error');
    }   
  }

  onFileChanged4(event) {
    var imagesize =Number(event.target.files[0].size)
    if(imagesize <= 300000){
      this.imgFile = event.target.files[0];
      this.preview4(event.target.files);
    } else{
      this.toastr.errorToastr("Profile image should be less than 300 kb ", 'Error');
    }   
  }
  
  preview(files) {
       if (files.length === 0){ return; }
       var mimeType = files[0].type;
       if (mimeType.match(/image\/*/) == null) { this.gstmessage = "Only images are supported."; return; }
       var reader = new FileReader();
       this.imagePath = files;
       reader.readAsDataURL(files[0]); 
       reader.onload = (_event) => { this.gstimage = reader.result;  this.gstmessage=''; }
  }
  preview1(files) {
       if (files.length === 0){ return; }
       var mimeType = files[0].type;
       if (mimeType.match(/image\/*/) == null) { this.panmessage = "Only images are supported."; return; }
       var reader = new FileReader();
       this.imagePath = files;
       reader.readAsDataURL(files[0]); 
       reader.onload = (_event) => { this.panimage = reader.result;  this.panmessage=''; }
  }
  preview2(files) {
       if (files.length === 0){ return;}
       var mimeType = files[0].type;
       if (mimeType.match(/image\/*/) == null) { this.aadharfmessage = "Only images are supported."; return; }
       var reader = new FileReader();
       this.imagePath = files;
       reader.readAsDataURL(files[0]); 
       reader.onload = (_event) => { this.aadharfimage = reader.result;  this.aadharfmessage=''; }
  }
  preview3(files) {
    console.log("fiesssssss ::::",files)
       if (files.length === 0){ return; }
       var mimeType = files[0].type;
       if (mimeType.match(/image\/*/) == null) { this.aadharbmessage = "Only images are supported."; return; }
       var reader = new FileReader();
       this.imagePath = files;
       reader.readAsDataURL(files[0]); 
       reader.onload = (_event) => { this.aadharbimage = reader.result;  this.aadharbmessage=''; }
  }
  preview4(files) {
    console.log("fiesssssss ::::",files)
       if (files.length === 0){ return; }
       var mimeType = files[0].type;
       if (mimeType.match(/image\/*/) == null) { this.aadharbmessage = "Only images are supported."; return; }
       var reader = new FileReader();
       this.imagePath = files;
       reader.readAsDataURL(files[0]); 
       reader.onload = (_event) => { this.image = reader.result;  this.message=''; }
  }
  userinfo(type){
    if(type == 'user'){
      this.usertype='user';
      this.regForm = this.fb.group({
        role_id:[''],
        name:['', Validators.required],
        email:['', Validators.required],
        mobile:['', [Validators.required, Validators.maxLength(10)]],
        password: ['', [Validators.required, Validators.minLength(6)]],
        confirmPassword: ['', [Validators.required,Validators.minLength(6)]],
      },{
        validator: MustMatch('password', 'confirmPassword')
      });
    }
    else{
      this.usertype = 'agent';  
      this.regForm = this.fb.group({
        role_id:[''],
        name:['', Validators.required],
        company_name:['', Validators.required],
        address_1:['', Validators.required],
        address_2:[''],
        city:['', Validators.required],
        state:['2'],
        country:['93', Validators.required],
        zipcode:['', Validators.required],
        // pan_no:['',[Validators.required,Validators.pattern]],
        pan_no:['',[Validators.required]],
        // gst_no:['',[Validators.required,Validators.pattern]],
        gst_no:[''],
        // gst_no:['',Validators.pattern],
        email:['', Validators.required],
        mobile:['', [Validators.required, Validators.maxLength(10)]],
        password: ['', [Validators.required, Validators.minLength(6)]],
        confirmPassword: ['', [Validators.required,Validators.minLength(6)]],
        //new fields
        aadhar_no:[''],
        // aadhar_no:['',[Validators.required,Validators.pattern]],
        pan:[''],
        gst:[''],
        image:[''],
        aadhaar_front:[''],
        aadhaar_back:['']
      },{
        validator: MustMatch('password', 'confirmPassword')
      });
    }  
  }


}
